module.exports = __webpack_public_path__ + "img/facebook-messenger-2.c34b7ee5.png";